import React, {useEffect, useState} from "react";
import HospitalEmailVerify from "./Components/HospitalDashbord/HospitalEmailVerify";
import HospitalCardViews from "./Components/HospitalDashbord/HospitalCardViews";
import { toast } from "react-toastify";
import { oneKlicks } from "../SDK/oneclick";

const HospitalDashboard = () => {
    const [userdata, setUserdata] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const userData = localStorage.getItem("userData");
                console.log("Raw userData from localStorage:", userData);
                
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    console.log("Parsed userData:", parsedData);
                    
                    // Verify user data with backend
                    const response = await oneKlicks.read("", "users", { id: parsedData.id }, "", "", "", "");
                    if (response.success && response.data.length > 0) {
                        const updatedUserData = response.data[0];
                        setUserdata(updatedUserData);
                        // Update localStorage with fresh data
                        localStorage.setItem("userData", JSON.stringify(updatedUserData));
                    } else {
                        console.error("Failed to verify user data with backend");
                        toast.error("Session expired. Please login again.");
                    }
                } else {
                    console.error("No user data found in localStorage");
                    toast.error("Please login to access the dashboard");
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
                toast.error("An error occurred while loading your data");
            } finally {
                setIsLoading(false);
            }
        };

        fetchUserData();
    }, []);

    if (isLoading) {
        return (
            <div className="subbody" style={{width: '100%', padding: '2% 4%'}}>
                <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="subbody" style={{width: '100%',padding: '2% 4%'}}>
                {!userdata.activation_key && (
                    <HospitalEmailVerify/>
                )}
                
                <HospitalCardViews/>
            </div>
        </>
    );
};

export default HospitalDashboard;
